var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.88,95.32c19-12.33,45-14.71,65.21-4,61.64,32.67,31.58,124.87,90,160.28,25.72,15.59,60.6,5.63,88.87,11.11,15.55,3,30.4,13.27,35.51,28.77,11.61,35.21-16.91,65.84-44.32,83.42-74.39,47.7-177.77,19.55-232.19-45.37a183.72,183.72,0,0,1-17.69-25c-19.38-33-27.31-72-25.68-110C84.07,159.41,91,116,122.88,95.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88,95.32c19-12.33,45-14.71,65.21-4,61.64,32.67,31.58,124.87,90,160.28,25.72,15.59,60.6,5.63,88.87,11.11,15.55,3,30.4,13.27,35.51,28.77,11.61,35.21-16.91,65.84-44.32,83.42-74.39,47.7-177.77,19.55-232.19-45.37a183.72,183.72,0,0,1-17.69-25c-19.38-33-27.31-72-25.68-110C84.07,159.41,91,116,122.88,95.32Z",
    style: {
      fill: "#fff",
      opacity: 0.9,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-29"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-29",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Script--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.58,
    y: 127.01,
    width: 104.42,
    height: 178.9,
    rx: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.58,
    y: 127.01,
    width: 104.42,
    height: 178.9,
    rx: 2.37,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 149.68,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 155.68,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.71,
    y: 149.68,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.04,
    y: 137.33,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 132.67,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 164,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 169.33,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 174.67,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 180,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 185.33,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 195.02,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 200.35,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 205.69,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 211.02,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 216.35,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 226.04,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 231.37,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 236.71,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 242.04,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 247.37,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 258.06,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 263.39,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 268.73,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 274.06,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 279.39,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.71,
    y: 294.77,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 149.68,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 155.68,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.71,
    y: 149.68,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.04,
    y: 137.33,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 132.67,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 164,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 169.33,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 174.67,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 180,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 185.33,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 195.02,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 200.35,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 205.69,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 211.02,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 216.35,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 226.04,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 231.37,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 236.71,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 242.04,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 247.37,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.67,
    y: 258.06,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 263.39,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 268.73,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 274.06,
    width: 89.71,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.67,
    y: 279.39,
    width: 79.7,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.71,
    y: 294.77,
    width: 19.67,
    height: 2.67,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--data-2--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.66,
    y: 265.3,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 274.79,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 274.79,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 304,
    width: 12,
    height: 6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 304,
    width: 34,
    height: 6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 296,
    width: 12,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 289,
    width: 12,
    height: 6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 296,
    width: 34,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 311,
    width: 34,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 289,
    width: 34,
    height: 6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 311,
    width: 12,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 281,
    width: 12,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 281,
    width: 34,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.93,
    y: 178.62,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.1,
    y: 176.25,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.1,
    y: 176.25,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 183,
    width: 15,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 183,
    width: 15,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 190,
    width: 15,
    height: 30,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 190,
    width: 15,
    height: 30,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 183,
    width: 15,
    height: 7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 190,
    width: 15,
    height: 30,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.83,
    y: 231.23,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.1,
    y: 228.02,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.1,
    y: 228.02,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 235,
    width: 23,
    height: 17,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 235,
    width: 23,
    height: 17,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 253,
    width: 23,
    height: 19,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 253,
    width: 23,
    height: 19,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,230.39V264H204.27a4.15,4.15,0,0,1-4.27-4.46V228h23.07C224.38,228,225,229.08,225,230.39Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.09,
    y: 131.49,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.1,
    y: 122.48,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.1,
    y: 122.48,
    width: 60.34,
    height: 50.13,
    rx: 2.37,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 129,
    width: 19,
    height: 5,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 135,
    width: 9,
    height: 31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 129,
    width: 10,
    height: 5,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 135,
    width: 10,
    height: 31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 135,
    width: 9,
    height: 31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 135,
    width: 16,
    height: 31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 129,
    width: 16,
    height: 5,
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--data-1--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.3,
    y: 239.69,
    width: 77.5,
    height: 77.5,
    rx: 4.71,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.42,
    y: 249.82,
    width: 57.58,
    height: 57.25,
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.42 307 332.08 294.95 336.87 298.81 352.05 285.99 359.51 293.33 375 280.33 375 307 317.42 307",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.42 307 329.83 283.72 344.33 285.98 355.17 271.82 366.33 273.83 375 265.17 375 307 317.42 307",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.42 307 346.05 303.46 355.33 298.82 365.33 299.82 375 295 375 307 317.42 307",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,240v8a5.22,5.22,0,0,1-5,5H316v23.48a4.77,4.77,0,0,1-5,4.52h-4V244.4c0-2.6,2.4-4.4,5-4.4Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 173.88,
    width: 77.5,
    height: 77.5,
    rx: 4.71,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.63,
    y: 181.97,
    width: 21.75,
    height: 13.03,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.52,
    y: 210,
    width: 17.59,
    height: 9.95,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.21,
    y: 210,
    width: 17.59,
    height: 9.95,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.16,
    y: 231.05,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.88,
    y: 231.05,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.61,
    y: 231.05,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.03,
    y: 231.05,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.75,
    y: 231.05,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "264 210 265 210 265 203 252 203 252 195 251 195 251 203 238 203 238 210 239 210 239 204 264 204 264 210",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238 226 225 226 225 231 226 231 226 227 238 227 238 231 239 231 239 220 238 220 238 226",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265 227 265 220 264 220 264 227 252 227 252 231 253 231 253 228 264 228 264 231 265 231 265 228 276 228 276 231 277 231 277 227 265 227",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290,178.59V201H235.07a5.25,5.25,0,0,1-5.07-5V174h55.71A4.27,4.27,0,0,1,290,178.59Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.18,
    y: 140.19,
    width: 77.5,
    height: 77.5,
    rx: 4.71,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.14,
    y: 150.31,
    width: 57.58,
    height: 57.25,
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.02,
    y: 185.5,
    width: 5.8,
    height: 14.87,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.02,
    y: 185.5,
    width: 5.8,
    height: 22.06,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.02,
    y: 175.08,
    width: 5.8,
    height: 21.89,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.02,
    y: 175.08,
    width: 5.8,
    height: 32.48,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.03,
    y: 181.49,
    width: 5.8,
    height: 17.57,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.03,
    y: 181.49,
    width: 5.8,
    height: 26.07,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.04,
    y: 172.49,
    width: 5.8,
    height: 23.64,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.04,
    y: 172.49,
    width: 5.8,
    height: 35.07,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.04,
    y: 158.74,
    width: 5.8,
    height: 32.9,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.04,
    y: 158.74,
    width: 5.8,
    height: 48.82,
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,140v42.4a4.72,4.72,0,0,1-4.83,4.6H319V144.89a5,5,0,0,1,4.88-4.89Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.27,
    y: 87.04,
    width: 77.5,
    height: 77.5,
    rx: 4.71,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.02,
    cy: 125.79,
    r: 25.41,
    transform: "translate(122.76 395.86) rotate(-80.78)",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,125.79l25,4.74a25.41,25.41,0,1,1-25-30.16Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,125.79,294,151.2a25.42,25.42,0,0,1,.07-50.83Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,125.79l-13.39-21.6a25,25,0,0,1,6.39-2.83,25.32,25.32,0,0,1,6.92-1Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.25,176s13.5,23.66,14.5,29.33-11.5,41.92-11.5,41.92,2.75,9.54-.25,11.15-8.24,4.85-9,2.1,0-11.82,0-11.82l2.26-1.93s8-37.88,8-39.19-14.51-23.65-14.51-23.65Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.48 407.03 370.37 407.88 369.96 403.18 368.85 390.39 376.96 389.53 378.19 403.66 378.48 407.03",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.96 406 411.1 406 411.03 404.22 411.02 404 410.62 392.6 410.61 392.37 410.45 388 418.32 388 418.96 406",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.96 389.53 378.19 403.66 369.96 403.18 368.85 390.39 376.96 389.53",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.91 405 418.9 405 411.03 404 411.02 404 410.61 393 410.62 393 418.5 393.63 418.9 404.65 418.91 405",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.28,187.33l-13.53,9.2-.26-.33-8.21-10.7-5-6.56,7.43-20.2C426.25,162,437.28,187.33,437.28,187.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.49,196.2l-8.21-10.7,6.59-10.11S425.9,185.83,423.49,196.2Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,405.53h9.55a.68.68,0,0,1,.67.54l1.55,7a1.18,1.18,0,0,1-1.15,1.4c-3.09-.05-5.34-.24-9.22-.24-2.39,0-9.6.25-12.9.25s-3.73-3.26-2.38-3.56c6.06-1.32,10.62-3.15,12.56-4.89A1.89,1.89,0,0,1,410,405.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.51,405.28h9.55a.68.68,0,0,1,.67.54l1.55,7a1.18,1.18,0,0,1-1.15,1.4c-3.09-.05-5.34-.24-9.22-.24-2.39,0-9.6.25-12.9.25s-3.73-3.26-2.38-3.56c6.06-1.32,10.62-3.15,12.56-4.89A1.89,1.89,0,0,1,369.51,405.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.11,402h11.53s-.94-99.25,11.53-132.77c.88,11.08,1.87,22.57,2.84,32.15.6,5.93,1.21,11,1.78,14.91,3.63,25,12.78,86.71,12.78,86.71H420s-1.36-59.14-2.7-83.7c-1.49-26.67-2.13-85.3-2.2-90.3H373.36C369.39,250,359.21,334,368.11,402Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.11,402h11.53s-.94-99.25,11.53-132.77c.88,11.08,1.87,22.57,2.84,32.15.6,5.93,1.21,11,1.78,14.91,3.63,25,12.78,86.71,12.78,86.71H420s-1.36-59.14-2.7-83.7c-1.49-26.67-2.13-85.3-2.2-90.3H373.36C369.39,250,359.21,334,368.11,402Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,140.87c.1.38.21.76.34,1.11a11,11,0,0,0,5.32,6.07,9.85,9.85,0,0,0,11.76-1.88c3.94-4,3.84-8.57,4.28-16.34a10.66,10.66,0,0,0-14.71-10.64C387.86,122.3,386.82,133.87,388.5,140.87Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,147.17a11,11,0,0,0,1.43.88,9.91,9.91,0,0,0,8.51.37,11.37,11.37,0,0,0-1.39-2.64A15.37,15.37,0,0,0,392.73,147.17Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,157.25c-3.83,3.48-13.21,2.19-13.21,2.19s-5.86-1.6-4.63-3.43c3.45-.57,5.12-2.18,5.81-4.24a10,10,0,0,0,.35-3.94,20.71,20.71,0,0,0-.29-2.2L408,137C406.49,142.71,404.63,153.14,408.38,157.25Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.23,124.39c.08.22-.12.67-.27,1.18a11.42,11.42,0,0,0-.42,3.07,12.67,12.67,0,0,0,4,9,50,50,0,0,0,3.5,9.11,1.94,1.94,0,0,0,.58.77,1.86,1.86,0,0,0,1.12.19l6.78-.23a1.37,1.37,0,0,0,1.09-.38,3.26,3.26,0,0,0,.25-.61c.61-1.46,3.19-.77,4.08-2.08a7.24,7.24,0,0,0,.53-1.86c.56-1.62,2.85-2.46,2.77-4.18-.05-1-1-1.9-.68-2.86s1.5-1.26,2-2.12,0-2-.55-2.8a3.67,3.67,0,0,1-.86-2.77,6.12,6.12,0,0,1,.52-1.06,3.69,3.69,0,0,0-.67-4.13,6.3,6.3,0,0,1-1.24-1.29c-.46-.87-.07-2-.63-2.87s-1.71-.84-2.69-.78-2.14,0-2.72-.74c-.42-.57-.4-1.38-.86-1.91-.66-.74-1.86-.54-2.79-.17s-1.95.84-2.85.43c-.63-.29-1-.93-1.57-1.31a2.27,2.27,0,0,0-2.67.15c-.5.43-.8,1.08-1.37,1.42a3.68,3.68,0,0,1-2.71,0,2.56,2.56,0,0,0-2.61.43c-.84,1,.07,2.78-.79,3.79-.49.58-1.39.66-1.92,1.2a1.54,1.54,0,0,0,.74,2.46c.3.06.69.08.8.36a2.5,2.5,0,0,1,.06.38c.11.39.66.41,1,.28C391.88,124.19,392.16,124.21,392.23,124.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.15,134.35a5,5,0,0,1-2.59,3.45c-1.58.67-2.62-1.56-2.39-3.89.22-2.08,1.29-5,3-4.61S397.7,132.26,397.15,134.35Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.17,269.18c.88,11.08,1.87,22.6,2.84,32.18,1.42-13.83,3.16-23.69,3.16-23.69s1.63-1.34,6.11-8.49,0-20.5,0-20.5C403.42,261.08,391.17,269.18,391.17,269.18Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,237.33,369.33,235a425.79,425.79,0,0,1,6.34-51.75,196.14,196.14,0,0,1,5-20.36,100.16,100.16,0,0,1,3.63-10S413.93,155.33,420,160,416.67,213,417,237.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.14,153.68s4.53-3.56,13-3.37,9.33,3.37,9.33,3.37,9.33,4.65,2,12.32-21.77-11.76-21.77-11.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.14,153.68s4.53-3.56,13-3.37,9.33,3.37,9.33,3.37,9.33,4.65,2,12.32-21.77-11.76-21.77-11.76Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.05,163.5S383,177,375.67,183.25a196.14,196.14,0,0,1,5-20.36Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.94,153.06s-29.61-6.05-33.77-7.64S319,122.79,319,122.79l-4.82,3.64s16.49,21.4,24.74,27.57S376,169.49,376,169.49Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,153.06l-25.79-4.71-.66,17.82L377.94,174S390.09,161.81,385.12,153.06Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,122.79c-2.37-2.71-11-8.56-12.27-9.06s-3.11,7.15-2.74,8.15,4.61,3.12,6.75,3.37,4.42,2.44,4.42,2.44Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.93 147.7 360.76 148.35 359.47 166.49 356.76 165.5 357.93 147.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.93 147.7 360.76 148.35 359.47 166.49 356.76 165.5 357.93 147.7",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422 196.38 437.28 186.03 438.33 188.67 423.77 197.83 422 196.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422 196.38 437.28 186.03 438.33 188.67 423.77 197.83 422 196.38",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.81 398.75 367.38 402 381 402 381 399 366.81 398.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.27 400 408.57 403 420 403 420.75 400 407.27 400",
    style: {
      fill: "#407BFF"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.e4bb526c6d113f844212d9598ba828a7.svg";
export { ForwardRef as ReactComponent };